module.exports = __webpack_public_path__ + "static/img/xs_case.f9db3c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xs_case.jpg
// module id = 7WzQ
// module chunks = 1